<script lang="ts">
  import { CheckIcon } from '@lucide/svelte'
  import ContextMenuItem from './ContextMenuItem.svelte'

  type Props = {
    name: string
    color?: string
    selected?: boolean
    onClick: () => void
  }
  const { name, color, selected, onClick }: Props = $props()
</script>

<ContextMenuItem {onClick}>
  <div class="item-container">
    <div class="item-content">
      {#if color}
        <span
          style:background={`var(--color-picker-${color})`}
          class="color"
          aria-label={color}
        ></span>
      {/if}
      <span class="name">{name}</span>
    </div>

    {#if selected}
      <CheckIcon size={12} />
    {/if}
  </div>
</ContextMenuItem>

<style lang="scss">
  .item-container {
    color: var(--context-menu-foreground);
    cursor: pointer;
    font-size: 0.75rem;
    overflow: hidden;
    text-align: start;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-height: 2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    width: 100%;

    .item-content {
      display: flex;
      flex-direction: row;
      gap: 0.25rem;
      align-items: center;
      justify-content: flex-start;
      width: 100%;

      .color {
        border: 0;
        display: block;
        width: 0.75rem;
        height: 0.75rem;
        border-radius: 0.125rem;
      }

      .name {
        font-size: 0.75rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 100%;
      }
    }
  }
</style>
